import React from "react";

/**
 * @param {import("react").ReactNode} node
 * @returns {string}
 */
export function getSelectOptionLabel(node) {
  if (node == null || typeof node === "boolean") {
    return "";
  }
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(getSelectOptionLabel).join("");
  }
  if (React.isValidElement(node)) {
    return getSelectOptionLabel(node.props.children);
  }
  return "";
}

/**
 * Reads native <option> children into ConstrainedSelect options.
 *
 * @param {import("react").ReactNode} children
 * @returns {Array<{ value: string, label: string, disabled?: boolean }>}
 */
export function collectSelectOptions(children) {
  /** @type {Array<{ value: string, label: string, disabled?: boolean }>} */
  const options = [];
  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child) || child.type !== "option") {
      return;
    }
    const value = child.props.value;
    options.push({
      value: value == null ? "" : String(value),
      label: getSelectOptionLabel(child.props.children),
      disabled: child.props.disabled === true,
    });
  });
  return options;
}
